module.exports = __webpack_public_path__ + "img/puesta-en-valor-3-zoom.a9f41666.jpg";